import { type ComponentType } from 'react';
import {
  QueryClient,
  QueryClientProvider,
  type QueryClientConfig,
} from '@tanstack/react-query';

const queryClientOptions: QueryClientConfig = {
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 0,
    },
  },
};

const client = new QueryClient(queryClientOptions);

export function islandRoot<T extends object>(Cmp: ComponentType<T>) {
  return (props: T) => {
    return (
      <QueryClientProvider client={client}>
        <Cmp {...props} />
      </QueryClientProvider>
    );
  };
}
